<template>
  <el-dialog
    title="生产标签"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="标签数量："
        prop="tagCount">
        <el-input-number
          v-model="info.tagCount"
          :max="200000"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="开始标签序号："
        prop="beginTagNo">
        <span>{{ info.beginTagNo }}</span>
      </el-form-item>
      <el-form-item label="结束标签序号：">
        <span>{{ endTagNo }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        :disabled="!endTagNo"
        @click="handleSubmit"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        tagCount: undefined,
        beginTagNo: null
      },
      rules: {
        tagCount: [
          { required: true, message: '请输入标签数量', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    endTagNo() {
      const { tagCount, beginTagNo } = this.info
      return tagCount && beginTagNo ? +tagCount + +beginTagNo - 1 : ''
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`account/addtagsegment`, {
            payload: {
              ...this.info,
              endTagNo: this.endTagNo
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
